import { render } from "./FormCard.vue?vue&type=template&id=1f908357&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"

import "./FormCard.vue?vue&type=style&index=0&id=1f908357&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f908357"]])

export default __exports__